import httpService from './core/http.service';

class OpsChangeInboxService {
    listSenders(companyId) {
        return httpService.get('/ops-change-inbox/senders', { companyId });
    }

    addSender(body) {
        return httpService.post('/ops-change-inbox/senders', body);
    }

    disableSender(id) {
        return httpService.put(`/ops-change-inbox/senders/${id}/disable`);
    }

    listThreads(companyId) {
        return httpService.get('/ops-change-inbox/threads', companyId ? { companyId } : {});
    }

    getThread(threadId) {
        return httpService.get(`/ops-change-inbox/threads/${encodeURIComponent(threadId)}`);
    }
}

export default new OpsChangeInboxService();
